import React, {useEffect, useRef, type FC} from 'react';
import {ArrowsDir} from '../../../../../constants';
import s from './ArrowButton.scss';
import {ChevronLeft, ChevronDown, ChevronRight, ChevronUp} from '@wix/wix-ui-icons-common/on-stage';
import classNames from 'classnames';
import {ARROW_BUTTON_SIZE} from '../utils/constants';
import {IconButton} from '@wix/wix-ui-tpa/cssVars';
import {classes as stylableClasses} from './ArrowButton.st.css';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../../../specs';

const ArrowIcon = ({direction}) => {
  const commonProps = {
    className: s.arrowSVG,
    width: ARROW_BUTTON_SIZE,
    height: ARROW_BUTTON_SIZE,
  };
  switch (direction) {
    case ArrowsDir.UP:
      return <ChevronUp {...commonProps} />;
    case ArrowsDir.DOWN:
      return <ChevronDown {...commonProps} />;
    case ArrowsDir.LEFT:
      return <ChevronLeft {...commonProps} />;
    case ArrowsDir.RIGHT:
      return <ChevronRight {...commonProps} />;
  }
};
export interface ArrowButtonProps {
  id: string;
  dataHook?: string;
  onClick: () => void;
  isVertical: boolean;
  direction: ArrowsDir;
}

export const ArrowButton: FC<ArrowButtonProps> = ({id, dataHook, onClick, isVertical, direction}) => {
  const buttonRef = useRef(null);
  const {experiments} = useExperiments();

  useEffect(() => {
    /* istanbul ignore next */
    if (!buttonRef.current || experiments.enabled(SPECS.ProductPageMainMediaNavigationArrows)) {
      return;
    }
    const buttonElement = buttonRef.current.wrappedComponentRef.innerComponentRef;
    setTimeout(() => buttonElement?.classList.remove(s.arrowButtonSSR), 0);
  }, [buttonRef, experiments]);

  return (
    <IconButton
      id={id}
      icon={<ArrowIcon direction={direction} />}
      data-hook={dataHook}
      type="button"
      innerRef={buttonRef}
      onClick={onClick}
      className={classNames(stylableClasses.arrowButton, s.arrowButton, s.arrowButtonSSR, {
        [s.arrowButtonVerticalSSR]: isVertical,
        [s.arrowButtonHorizontalSSR]: !isVertical,
      })}
    />
  );
};
